import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  category: string;
  tags: string[];
  status: string;
  rating: number;
  views: number;
  cover: string;
  updatedAt: string;
}

export default function ComicCard({ id, title, author, tags, status, rating, views, cover, updatedAt }: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[5/7] mb-3 bg-background-200">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
            status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm rounded-md px-1.5 py-0.5">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          <span className="text-background-50 text-xs font-medium">{rating}</span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/80 to-transparent p-3 pt-8">
          <h3 className="text-background-50 text-sm font-semibold font-heading truncate">
            {title}
          </h3>
        </div>
      </div>
      <div className="px-0.5">
        <div className="flex items-center gap-2 text-xs text-foreground-500 mb-1">
          <span>{author}</span>
          <span className="text-foreground-300">·</span>
          <span>{formatViews(views)} 阅读</span>
        </div>
        <div className="flex flex-wrap gap-1">
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}